// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__30vIm","label":"Completed_label__2hWuk"};